const ExtensionType = Object.freeze({
  regular: "regular",
  virtual: "virtual",
});

export default ExtensionType;
